import React, { useState } from "react";
import "./Admin_dashboard.css";
import "./DeleteStudent.css";
import { Underline, Floatinmenu } from "../../widgets";
import { admin_menu } from "../../constants/dashboard";
import axios from "axios";

export default function DeleteStudent() {
    const [regno, setRegno] = useState("");
    const [confirmStep, setConfirmStep] = useState(false);

    const handleInitialSubmit = (e) => {
        e.preventDefault();
        if (regno.length !== 11) {
            alert("Please enter a valid 11-digit registration number");
            return;
        }
        setConfirmStep(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await axios.post("backend/deletestudent", {
                regno,
                confirm: true,
            });
            if (res.data.Status === "Success") {
                alert("Student deleted successfully");
                setRegno("");
                setConfirmStep(false);
            } else {
                alert(res.data.message || "Failed to delete student");
                setConfirmStep(false);
            }
        } catch (error) {
            console.error("Delete Error:", error);
            alert("Error deleting student");
            setConfirmStep(false);
        }
    };

    const handleCancel = () => {
        setConfirmStep(false);
    };

    return (
        <div className="delete_student_container">
            <Underline heading="Delete Student" />
            <Floatinmenu head="Menu" links={admin_menu} />
            <div className="delete_student_content">
                
                <form className="delete_student_form" onSubmit={handleInitialSubmit}>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="regno"
                            id="regno"
                            value={regno}
                            onChange={(e) => setRegno(e.target.value)}
                            placeholder=" "
                            required
                            autoComplete="off"
                        />
                        <label htmlFor="regno">REGISTRATION NUMBER</label>
                    </div>
                    {!confirmStep && (
                        <button className="submit_button" type="submit">
                            Delete Student
                        </button>
                    )}
                </form>

                {confirmStep && (
                    <div className="confirm_box">
                        <p>Are you sure you want to delete this student?</p>
                        <button className="confirm_button" onClick={handleConfirmDelete}>
                            Yes, Delete
                        </button>
                        <button className="cancel_button" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                )}
            </div>
            <div className="logout_button">
            <a className="log_link" href="/logout">
              Logout
            </a>
            </div>
        </div>
    );
}
